<template>
  <div class="filter-approve">
    <span>Фильтр списка (нажмите что бы просмотреть):</span>
    <el-row type="flex" align="middle">
      <div class="titles">
        <div
          class="approved"
          :class="status === '1' ? 'active' : ''"
          @click="$emit('setStatus', '1')"
        >
          Проверенные
        </div>
        <div
          class="prepending"
          :class="status === '0' ? 'active' : ''"
          @click="$emit('setStatus', '0')"
        >
          На проверке
        </div>
        <div
          class="rejected"
          :class="status === '2' ? 'active' : ''"
          @click="$emit('setStatus', '2')"
        >
          Отклоненные
        </div>
        <div
          class="all"
          :class="status ? '' : 'active'"
          @click="$emit('setStatus')"
        >
          Все
        </div>
      </div>
      <loader-wrapper :loading="loading" background="rgba(249,249,249,.9)">
        <div class="results" :class="auto ? 'auto' : ''">
          <div class="approved">{{ statistics.approved }}</div>
          <div class="prepending">{{ statistics.waiting }}</div>
          <div class="rejected">{{ statistics.denied }}</div>
          <div class="all">{{ total }}</div>
        </div>
      </loader-wrapper>
    </el-row>
  </div>
</template>

<script>
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'ApproveFilters',
  components: { LoaderWrapper },
  props: {
    statistics: {
      type: Object,
      default: () => {},
    },
    auto: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    total() {
      const obj = this.statistics

      return (obj.waiting || 0) + (obj.approved || 0) + (obj.denied || 0)
    },
  },
}
</script>

<style lang="sass">
.filter-approve
  font-size: 14px
  line-height: 24px
  text-align: right
  span
    font-size: 18px
    cursor: default
  .el-row
    text-align: right
    margin-top: 15px
  .titles
    width: 100%
    div
      &:hover
        text-decoration: underline
        cursor: pointer
      &.active
        text-decoration: underline
        font-weight: bold
  .results
    width: 100px
    div
      position: relative
      cursor: default
      &:before
        content: ""
        position: absolute
        width: 18px
        height: 21px
        background: url("~@/assets/img/img-user.svg")
        right: 45px
        top: 0
    &.auto div:before
      width: 27px
      height: 27px
      top: -5px
      background: url("~@/assets/img/big-truck.svg")
  .approved
    color: #3498DB
  .prepending
    color: #DBB634
  .rejected
    color: #2ECC71
  .all
    color: #252631
</style>
